import * as Yup from "yup";
import { getLocalizedMessage } from "../UtilityFunctions/utils";

export const planAuditFieldName = {
  PLANNED_MONTH: "planned_month",
  AUDIT_TYPE: "audit_type",
  PRODUCT_SUB_CATEGORY_ID: "product_sub_category_id",
  TM_ID: "tm_id",
  DNSD: "dnsd",
  TENTATIVE_DATE: "tentative_date",
  DNSD_OBJ_ARR: "dnsdObjArr",
};

export const planAuditInitialValues1 = {
  [planAuditFieldName.PLANNED_MONTH]: "",
  [planAuditFieldName.AUDIT_TYPE]: "",
  [planAuditFieldName.PRODUCT_SUB_CATEGORY_ID]: "",
  [planAuditFieldName.TM_ID]: "",
  [planAuditFieldName.DNSD]: [],
  [planAuditFieldName.TENTATIVE_DATE]: [],
};

export const planAuditInitialValues = {
  [planAuditFieldName.AUDIT_TYPE]: "",
  [planAuditFieldName.PRODUCT_SUB_CATEGORY_ID]: "",
  [planAuditFieldName.DNSD]: [],
  [planAuditFieldName.DNSD_OBJ_ARR]: [],
};

export const planAuditValidationSchema1 = (intl) =>
  Yup.object().shape({
    [planAuditFieldName.PLANNED_MONTH]: Yup.string().required(
      getLocalizedMessage(intl, "planAudit.fieldError.plannedMonth.required")
    ),
    [planAuditFieldName.AUDIT_TYPE]: Yup.string().required(
      getLocalizedMessage(intl, "planAudit.fieldError.auditType.required")
    ),
    [planAuditFieldName.PRODUCT_SUB_CATEGORY_ID]: Yup.number().when(
      planAuditFieldName.AUDIT_TYPE,
      {
        is: (auditType) => auditType === "Repair",
        then: () =>
          Yup.string().required(
            intl.formatMessage({
              id: "planAudit.fieldError.productSubProduct.required",
            })
          ),
        otherwise: () => Yup.string().nullable(),
      }
    ),
    [planAuditFieldName.DNSD]: Yup.number().when(
      planAuditFieldName.PRODUCT_SUB_CATEGORY_ID,
      {
        is: (subcategoryId) => !subcategoryId || !!subcategoryId,
        then: () =>
          Yup.array()
            .of(
              Yup.number().required(
                intl.formatMessage({
                  id: "planAudit.fieldError.dnsd.required",
                })
              )
            )
            .min(
              1,
              intl.formatMessage({
                id: "planAudit.fieldError.select.atLeast1",
              })
            ),
        otherwise: () => Yup.array().nullable(),
      }
    ),
    [planAuditFieldName.TM_ID]: Yup.number().when(
      planAuditFieldName.PRODUCT_SUB_CATEGORY_ID,
      {
        is: (subcategoryId) => !subcategoryId || !!subcategoryId,
        then: () =>
          Yup.string()
            .nullable()
            .required(
              intl.formatMessage({
                id: "planAudit.fieldError.tm.required",
              })
            ),
        otherwise: () => Yup.string().nullable(),
      }
    ),
    [planAuditFieldName.TENTATIVE_DATE]: Yup.array()
      .of(
        Yup.string().required(
          intl.formatMessage({
            id: "planAudit.fieldError.tentativeDate.required",
          })
        )
      )
      .required(
        intl.formatMessage({
          id: "planAudit.fieldError.tentativeDate.required",
        })
      ),
  });

export const planAuditValidationSchema = (intl) =>
  Yup.object().shape({
    [planAuditFieldName.AUDIT_TYPE]: Yup.string().required(
      getLocalizedMessage(intl, "planAudit.fieldError.auditType.required")
    ),
    [planAuditFieldName.PRODUCT_SUB_CATEGORY_ID]: Yup.number().when(
      planAuditFieldName.AUDIT_TYPE,
      {
        is: (auditType) => auditType === "Repair",
        then: () =>
          Yup.string().required(
            intl.formatMessage({
              id: "planAudit.fieldError.productSubProduct.required",
            })
          ),
        otherwise: () => Yup.string().nullable(),
      }
    ),
    [planAuditFieldName.DNSD]: Yup.number().when(
      planAuditFieldName.PRODUCT_SUB_CATEGORY_ID,
      {
        is: (subcategoryId) => !subcategoryId || !!subcategoryId,
        then: () =>
          Yup.array()
            .of(
              Yup.number().required(
                intl.formatMessage({
                  id: "planAudit.fieldError.dnsd.required",
                })
              )
            )
            .min(
              1,
              intl.formatMessage({
                id: "planAudit.fieldError.select.atLeast1",
              })
            ),
        otherwise: () => Yup.array().nullable(),
      }
    ),
    dnsdObjArr: Yup.array().of(
      Yup.object().shape({
        dnsd_id: Yup.number(),
        [planAuditFieldName.TENTATIVE_DATE]: Yup.string().required(
          intl.formatMessage({
            id: "planAudit.fieldError.tentativeDate.required",
          })
        ),
        [planAuditFieldName.TM_ID]: Yup.number().required(
          intl.formatMessage({
            id: "planAudit.fieldError.tm.required",
          })
        ),
      })
    ),
  });
